/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserEventSchema } from '../models/UserEventSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GroupVisitsCalendarApi {
    /**
     * Get Group Visits Calendar
     * Get group visits calendar for the given company.
     * @returns UserEventSchema OK
     * @throws ApiError
     */
    public static groupVisitCalendarGetGroupVisitsCalendarGet({
        companyId,
        startDate,
        endDate,
    }: {
        companyId: string,
        startDate: string,
        endDate: string,
    }): CancelablePromise<Array<UserEventSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/group-visits-calendar/{company_id}/',
            path: {
                'company_id': companyId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
        });
    }
}
